import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateNativeAdapter,
  NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { TransactionForm } from 'src/app/classes/form-groups/transaction-form';
import { CustomNgbDateFormatter } from 'src/app/dependencies/custom-ngb-date-formatter';
import { InvoiceService } from 'src/app/services/invoice.service';
import { PaymentProviderService } from 'src/app/services/payment-provider.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-transaction-modal',
  templateUrl: './transaction-modal.component.html',
  styleUrls: ['./transaction-modal.component.less'],
  providers: [
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateFormatter }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TransactionModalComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private InvoiceService: InvoiceService,
    private ActiveModal: NgbActiveModal,
    private UtilityService: UtilityService,
    private PaymentProviderService: PaymentProviderService
  ) {}

  @Input() TransactionFormGroup!: TransactionForm;

  TransactionTypes: ['CREDIT', 'DEBIT'] = ['CREDIT', 'DEBIT'];
  TransactionMethods: ['ONLINE', 'CASH', 'CHECK'] = ['ONLINE', 'CASH', 'CHECK'];

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.TransactionFormGroup
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There are errors with the form below.',
        { returnError: true }
      );
    }

    this.TransactionFormGroup.patchValue({
      status: 'Approved',
      Invoice: { status: 'PAID' }
    });
    const Transaction = this.TransactionFormGroup.getRawValue();
    const { Invoice } = Transaction;
    Object.assign(Transaction, { Invoice: undefined });
    Object.assign(Invoice, { Transactions: [Transaction] });

    this.InvoiceService.saveInvoice(Invoice, {
      isManualPayment: true
    }).subscribe({
      next: (SavedInvoice) => {
        this.ActiveModal.close(SavedInvoice);
        this.ToastService.addSuccessToast(
          'Success',
          'Successfully updated Invoice.'
        );
      }
    });
  }

  close() {
    this.ActiveModal.dismiss();
  }

  ngOnInit(): void {
    if (!this.TransactionFormGroup) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Transaction form.',
        { returnError: true }
      );
    }

    const {
      controls: { Invoice }
    } = this.TransactionFormGroup;

    if (!Invoice) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Invoice on Transaction.',
        { returnError: true }
      );
    }

    this.TransactionFormGroup.controls['amount'].disable();

    this.PaymentProviderService.getPaymentProvider({
      name: 'Payabli'
    }).subscribe({
      next: (PayabliPaymentProvider) => {
        if (!PayabliPaymentProvider) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Missing Payment Provider information.',
            { returnError: true }
          );
        }

        const { id: PaymentProviderId } = PayabliPaymentProvider;

        if (!PaymentProviderId) {
          throw this.ToastService.addErrorToast(
            'Error',
            'Payment Provider is missing id.',
            { returnError: true }
          );
        }

        this.TransactionFormGroup.patchValue({ PaymentProviderId });
      }
    });
  }
}
